import { lang, commonLang } from '@umu/ukit-lang';
import { $location } from '@umu/umu-dom';
import { IShareConfig, IShare, ICallback } from '@umu/umu-types';
import { getShareIcon } from './shareCommon';

export abstract class BaseShare implements IShare {
    public shareConfig: IShareConfig = {
        title: commonLang('UMU 互动学习平台'),
        desc: lang(
            '用手机随时组织互动与微课，用大屏幕同步展示学习结果，让互联网升级线上线下课堂，让每个人融入、分享、收获。',
        ),
        link: this.getDefaultShareUrl(),
        imgUrl: getShareIcon(),
        shareUrl: this.getDefaultShareUrl(),
    };

    public abstract setup(config?: IShareConfig, callback?: ICallback): void;

    public getShareConfig() {
        return this.shareConfig;
    }

    public getDefaultShareUrl() {
        return this.filter();
    }

    public mergeSetup(wxConfig?: IShareConfig) {
        const config = wxConfig || ({} as IShareConfig);
        for (const key in this.shareConfig) {
            if (this.shareConfig.hasOwnProperty(key)) {
                const prop = key as keyof IShareConfig;
                this.shareConfig[prop] = config[prop] || this.shareConfig[prop] || '';
            }
        }
        this.shareConfig.link = this.filter(this.shareConfig.link);
        this.shareConfig.shareUrl = this.filter(this.shareConfig.shareUrl);
    }

    /**
     * @description 去掉不必要的分享参数
     */
    public filter(url?: string) {
        url = url || $location.href;
        url = url.replace(/((?:code|anti_fraud_code|JSESSID)=[^&#]*&?)/g, '');
        return url;
    }
}
